import React from 'react';
import { DropdownMenuContentProps } from '@radix-ui/react-dropdown-menu';
import MenuPopover, { MenuPopoverProps } from '../../components/menu-popover';
import { BoxProps, Div } from '../../components/box';
import Panel from '../../components/panel';
import Icon from '../../components/icon';
import { SquareButton } from '../../components/button';
import { AccessibleMenuItemProps } from '../../components/menu-popover/menu-item';
import { SquareButtonProps } from '../../components/button/square-button';

const SkillInfo = (props: BoxProps) => (
  <Panel
    variant={'white'}
    paddingTop={'xxs'}
    paddingHorizontal={'xs'}
    paddingBottom={'sm'}
    display={'flex'}
    flexDirection={'column'}
    gap={'sm'}
    width={400}
    {...props}
  />
);

export type SkillMenuButtonProps = Omit<SquareButtonProps, 'aria-label'> & {
  // make aria-label optional not like in square button props
  'aria-label'?: string;
};

export const SkillMenuButton = ({ 'aria-label': ariaLabel, loading, ...props }: SkillMenuButtonProps) => (
  <MenuPopover.Button
    size={'xs'}
    aria-label={ariaLabel || 'open skill menu'}
    style={{ position: 'relative', left: 3 }}
    as={SquareButton}
    {...props}
    variant={'secondary-clean'}
    className={'menu-trigger'}
    loading={loading}
  >
    {<Icon name={'ARROW_DROP_DOWN'} style={{ fontSize: 20 }} />}
  </MenuPopover.Button>
);

SkillMenuButton.displayName = 'SkillMenuButton';

export const SkillMenu: React.FunctionComponent<MenuPopoverProps> & {
  Info: React.FunctionComponent<BoxProps>;
  MenuButton: React.FunctionComponent<SkillMenuButtonProps>;
  Items: React.FunctionComponent<DropdownMenuContentProps>;
  Item: React.FunctionComponent<AccessibleMenuItemProps>;
} = (props: MenuPopoverProps) => (
  <Div width={'max-content'}>
    <MenuPopover size={'auto'} {...props} />
  </Div>
);

SkillMenu.Info = SkillInfo;
SkillMenu.MenuButton = SkillMenuButton;
SkillMenu.Items = MenuPopover.Items;
SkillMenu.Item = MenuPopover.Item;
